import { useState } from 'react';

import {
  ChakraAvatar,
  ChakraBox,
  ChakraFlex,
  ChakraText,
  ChatUser,
  EquipUITheme,
  Group,
  Popover,
} from '@equip.health/ui';

const idPrefix = 'members';
const idPostfix = 'popover';

const { label, caption, h6 } = EquipUITheme.typography;
const popoverBody = (id: string, members: ChatUser[]) => {
  return (
    <ChakraBox id={`${idPrefix}-popover-container__${id}__${idPostfix}`}>
      {(members ?? []).map((member) => (
        <ChakraFlex
          id={`${idPrefix}-popover-wrapper__${member.userId}__${idPostfix}`}
          key={`members-popover-patient-messages-${member?.userId}`}
          padding="10px"
        >
          <ChakraAvatar
            background="orange.50"
            borderColor="neutral.primary"
            borderWidth="4px"
            color="black"
            id={member.userId}
            name={member.nickname}
            showBorder
            size="md"
          />
          <ChakraBox
            id={`${idPrefix}-nickname-wrapper__${member.userId}__${idPostfix}`}
            paddingLeft="12px"
          >
            <ChakraText
              color="neutral.primary"
              {...h6}
              id={`${idPrefix}-nickname__${member.userId}__${idPostfix}`}
            >
              {member.nickname}
            </ChakraText>
            <ChakraText
              color="neutral.secondary"
              id={`${idPrefix}-provider-type__${member.userId}__${idPostfix}`}
              {...caption}
              lineHeight="16.8px"
            >
              {member.metaData.providerType}
            </ChakraText>
          </ChakraBox>
        </ChakraFlex>
      ))}
    </ChakraBox>
  );
};

interface MembersPopoverListProps {
  id: string;
  members: ChatUser[];
}

const MembersPopoverList = ({ id, members }: MembersPopoverListProps) => {
  const [showUserPopover, setShowUserPopover] = useState<boolean>(false);
  const [isHighlighted, setIsHighlighted] = useState<boolean>(false);

  return (
    <Popover
      bodyContent={popoverBody(id, members)}
      headerContent={
        <ChakraFlex
          id={`${idPrefix}-group-member-container__${id}__${idPostfix}`}
          padding="10px"
        >
          <ChakraText
            color="neutral.secondary"
            {...label}
            id={`${idPrefix}-group-members-label__${id}__${idPostfix}`}
          >
            Group members
          </ChakraText>
        </ChakraFlex>
      }
      id={id}
      isOpen={showUserPopover}
      onClose={() => setShowUserPopover(false)}
      onOpen={() => setShowUserPopover(true)}
      size="md"
      triggerContent={
        <ChakraBox
          cursor="pointer"
          onMouseEnter={() => setIsHighlighted(true)}
          onMouseLeave={() => setIsHighlighted(false)}
        >
          <Group
            fill={isHighlighted ? 'primary' : 'neutral.primary'}
            height="12px"
            width="12px"
          />
        </ChakraBox>
      }
    />
  );
};

export default MembersPopoverList;
